import React from 'react';
import Grid from '@mui/material/Grid';
import { useSelector } from 'react-redux';
import makeStyles from '@mui/styles/makeStyles';
import { RootState } from '@/rootStateTypes';
import { PizzaMenu as CCPizzaMenu } from '@/clientCore/menu';
import { mobileStartBreakpoint } from '../../../materialUi/theme';
import { NATIONAL } from '../../../localization/constants';
import Menu from '../../Menu';
import pizzaData from '../../../common/pageSetup/nationalData/pizzaData';

const useStyles = makeStyles((theme) => ({
  grid: {
    width: '65%',
    [theme.breakpoints.down(mobileStartBreakpoint)]: {
      width: '100%'
    }
  }
}));

const PizzaMenu = (): JSX.Element => {
  const classes = useStyles();

  const isLocalized = useSelector(
    (state: RootState) => state.domain.localization.localizedStore !== NATIONAL
  );

  return (
    <Grid data-testid="pizza-menu-page" className={classes.grid}>
      {isLocalized ? (
        <CCPizzaMenu />
      ) : (
        <Menu
          items={pizzaData()}
          title="Pizza"
          minimumDisplayedItems={4}
          itemsTestId="national-pizza-menu"
          seeMoreLess
          vegetarianLegend
          isNational
        />
      )}
    </Grid>
  );
};

export default PizzaMenu;
